import { DashboardSegmentsConfig } from "../types";

export enum DashboardSegmentActions {
	SET_SEGMENTS = "SET_SEGMENTS",
	CHANGE_SELECTED_SEGMENT = "CHANGE_SELECTED_SEGMENT",
	CHANGE_SELECTED_SEGMENT_NON_MOBILE_GRID_CONFIG = "CHANGE_SELECTED_SEGMENT_NON_MOBILE_GRID_CONFIG",
}

export const dashboardSegmentsReducer = (state: DashboardSegmentsConfig, action: Record<string, any>) => {
	const { payload } = action;

	switch (action.type) {
		case DashboardSegmentActions.SET_SEGMENTS:
			return { ...state, allSegments: payload };
		case DashboardSegmentActions.CHANGE_SELECTED_SEGMENT:
			return { ...state, selectedSegment: payload };
		case DashboardSegmentActions.CHANGE_SELECTED_SEGMENT_NON_MOBILE_GRID_CONFIG:
			return {
				...state,
				selectedSegment: {
					...state.selectedSegment,
					value: {
						...state.selectedSegment.value,
						dashboardEdit: {
							...state.selectedSegment.value.dashboardEdit,
							nonMobileGridConfig: payload,
						},
					},
				},
			};
		default:
			return state;
	}
};
